import { DsbcApiOptions } from '../_dsapi/DsbcApiOptions';
import { createDsbcApiUrl } from '../createDsbcApiUrl';
import { DsbcApi } from '../createDsbcRequest';
import { BaseRequest, BaseResponse } from '../shared';

interface getInvUserRequest extends BaseRequest {
  invId: string; //邀请活动ID
}

export interface InvUserResVO {
  /**
   * 邀请用户等级
   * 1 - V1
   * 2 - V2
   * 3 - V3
   */
  level: string;
  /**
   * 晋级方式
   * 0 无
   * 1 实名认证
   * 2 学生认证
   * 3 校园合伙人
   * 为0时，按钮展示”我知道了“
   */
  promWay: string;
  /**
   * 是否达到邀请人数上线-0 否；1 是
   * */
  invLimit: string;
}

interface getSumCashResponse extends BaseResponse {
  Data: InvUserResVO;
}

/**
 * 查询邀请人信息
 * 用户每次进入活动页面都需要调用一次接口，用来查询邀请人信息，比如等级
 * */
export async function getInvUser(request: getInvUserRequest, options?: DsbcApiOptions) {
  const url = await createDsbcApiUrl('/inv/getInvUser');
  return DsbcApi.fetch<getSumCashResponse>(url, request, true, options);
}
